import { injectable, interfaces } from 'inversify';
import { makeObservable, observable } from 'mobx';

export interface ISideNavigationStore {
  isExpanded: boolean;
}

export namespace ISideNavigationStore {
  export const $: interfaces.ServiceIdentifier<ISideNavigationStore> = Symbol('SIDE_NAVIGATION_STORE');
}

@injectable()
export class SideNavigationStore implements ISideNavigationStore {
  isExpanded: boolean = true;

  constructor() {
    makeObservable(this, {
      isExpanded: observable,
    });
  }
}
